export default function promiseAllSettled<T extends ReadonlyArray<unknown> | []>(
  values: T,
): Promise<{ -readonly [P in keyof T]: PromiseSettledResult<Awaited<T[P]>> }> {
  // eslint-disable-next-line no-restricted-syntax
  return Promise.allSettled(values);
}
